import type { Shift } from './mock-data'

/**
 * A `shifts` row as the till holds it — numeric columns made numbers. Moved out of
 * lib/store.tsx (1.57) so the columns the Z prints are pinned by a test: a column
 * close_shift() freezes but this mapper drops prints as nothing on the paper.
 */

const num = (v: unknown) => (v == null ? 0 : Number(v))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mapShift(r: any): Shift {
  return {
    id: r.id,
    cashier_id: r.cashier_id ?? null,
    cashier_name: r.cashier_name ?? null,
    status: r.status ?? 'open',
    opening_cash: num(r.opening_cash),
    closing_cash: r.closing_cash == null ? null : num(r.closing_cash),
    cash_sales: num(r.cash_sales),
    card_sales: num(r.card_sales),
    credit_sales: num(r.credit_sales),
    credit_paid: num(r.credit_paid),
    returns_total: num(r.returns_total),
    sales_count: num(r.sales_count),
    customer_payments_cash: num(r.customer_payments_cash),
    supplier_payments_cash: num(r.supplier_payments_cash),
    expected_cash: num(r.expected_cash),
    difference: num(r.difference),
    cash_in_total: num(r.cash_in_total),
    cash_out_total: num(r.cash_out_total),
    change_kept_in: num(r.change_kept_in),
    change_kept_out: num(r.change_kept_out),
    // 176 — frozen by close_shift(): money taken for / handed back from a gift card or a
    // deposit, and the sales a prepaid paid (0 for a shift closed before 176)
    prepaid_in_cash: num(r.prepaid_in_cash),
    prepaid_in_card: num(r.prepaid_in_card),
    prepaid_out_cash: num(r.prepaid_out_cash),
    prepaid_out_card: num(r.prepaid_out_card),
    prepaid_sales: num(r.prepaid_sales),
    closing_float: r.closing_float == null ? null : num(r.closing_float),
    takeout_reason: r.takeout_reason ?? null,
    takeout_note: r.takeout_note ?? null,
    takeout_bank: r.takeout_bank ?? null,
    closing_salary: r.closing_salary == null ? null : num(r.closing_salary),
    opening_carried: r.opening_carried == null ? null : num(r.opening_carried),
    branch_id: r.branch_id ?? null,
    opened_at: r.opened_at,
    closed_at: r.closed_at ?? null,
  }
}
